function TablerList () {
  return (
      <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.00016 1H11.3335M4.00016 5H11.3335M4.00016 9H11.3335M1.3335 1V1.00667M1.3335 5V5.00667M1.3335 9V9.00667" stroke="#0D0E0F" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
  )
}

export default TablerList;